module.exports = __webpack_public_path__ + "media/images/webpage/hotels/895/meal-f08494aee29a6b25f0bf3f3746278c48.webp";